import { application } from "../../application";
import { registerControllers } from "stimulus-vite-helpers";

// Controller files must be named *_controller.js.
const controllers = import.meta.glob("./**/*_controller.js", { eager: true });
registerControllers(application, controllers);
